import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/provider'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ProviderCommonApi {

    static async updatePairs({ data = { providerId: undefined }, ...params }) {
        return await fetchService({ url: '/updatepairs', method: 'POST', data, ...params })
    }




    static async addToMegamarket({ data = { skus: undefined, shop: undefined, min_profit: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtomegamarket', method: 'POST', data, ...params })
    }

    static async addToYandex({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtoyandex', method: 'POST', data, ...params })
    }

    static async addToWb({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtowb', method: 'POST', data, ...params })
    }

    static async addToOzon({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtoozon', method: 'POST', data, ...params })
    }

    static async addToAvito({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtoavito', method: 'POST', data, ...params })
    }

    static async addToBwhite({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtobwhite', method: 'POST', data, ...params })
    }



    static async addToOzonFromWarehouse({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtoozonwarehouse', method: 'POST', data, ...params })
    }

    static async addToYandexFromWarehouse({ data = { skus: undefined, shop: undefined, min_profit: undefined, extra: undefined, fromWarehouse: undefined }, ...params }) {
        return await fetchService({ url: '/addtoyandexwarehouse', method: 'POST', data, ...params })
    }



    static async saveDefault({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/savedefault', method: 'POST', data, ...params })
    }

    static async saveContent({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/savecontent', method: 'POST', data, ...params })
    }

    static async saveWbData({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/savewbdata', method: 'POST', data, ...params })
    }

    static async saveOzonProps({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/saveozonprops', method: 'POST', data, ...params })
    }

    static async saveAvitoData({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/saveavitodata', method: 'POST', data, ...params })
    }

    static async saveAvitoProps({ data = { file: undefined }, ...params }) {
        return await fetchService({ url: '/saveavitoprops', method: 'POST', data, ...params })
    }

    // static async saveAvitoProps1({ data = { file: undefined }, ...params }) {
    //     return await fetchService({ url: '/saveavitoprops1', method: 'POST', data, ...params })
    // }




    static async excelDefault({ data = { tab: undefined, providerId: undefined, search: undefined, markets: undefined, market: undefined, shop: undefined, contentFilters: undefined }, ...params }) {
        return await fetchService({ url: '/exceldefault', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelContent({ data = { tab: undefined, providerId: undefined, search: undefined, market: undefined, shop: undefined, markets: undefined, contentFilters: undefined, }, ...params }) {
        return await fetchService({ url: '/excelcontent', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelWbData({ data = { tab: undefined, providerId: undefined, search: undefined, market: undefined, shop: undefined, markets: undefined, contentFilters: undefined, }, ...params }) {
        return await fetchService({ url: '/excelwbdata', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelAvitoData({ data = { tab: undefined, providerId: undefined, search: undefined, market: undefined, shop: undefined, markets: undefined, contentFilters: undefined }, ...params }) {
        return await fetchService({ url: '/excelavitodata', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelOzonProperties({ data = { tab: undefined, providerId: undefined, search: undefined, market: undefined, shop: undefined, markets: undefined, contentFilters: undefined, }, ...params }) {
        return await fetchService({ url: '/excelozonprops', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelAvitoProperties({ data = { tab: undefined, providerId: undefined, search: undefined, market: undefined, shop: undefined, markets: undefined, contentFilters: undefined }, ...params }) {
        return await fetchService({ url: '/excelavitoprops', method: 'POST', data, options: { download: true }, ...params })
    }




    static async excelCheckContent({ data = { tab: undefined, providerId: undefined, search: undefined, market: undefined, shop: undefined, markets: undefined, contentFilters: undefined }, ...params }) {
        return await fetchService({ url: '/excelcheckcontent', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelContentStatistic({ data = { market: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/excelcontentstatistic', method: 'POST', data, options: { download: true }, ...params })
    }



    static async excelCommonData({ data = { skus: undefined }, ...params }) {
        return await fetchService({ url: '/exceldata', method: 'POST', data, ...params })
    }

    static async excelPrices({ data = { tab: undefined, providerId: undefined, search: undefined, page: undefined, markets: undefined, contentFilters: undefined }, ...params }) {
        return await fetchService({ url: '/excelprices', method: 'POST', data, ...params })
    }

    // static async excelTz({ data = { tab: undefined, providerId: undefined, search: undefined, markets: undefined, minProfit: undefined, partTz: undefined, contentFilters: undefined, }, ...params }) {
    //     return await fetchService({ url: '/exceltz', method: 'POST', data, ...params })
    // }




    static async getProductsBySearch({ data = { providerId: undefined, search: undefined, tab: undefined, markets: undefined, contentFilters: undefined, page: undefined, limit: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/getproducts', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getProduct({ data = { sku: undefined }, ...params }) {
        return await fetchService({ url: '/getproduct', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async changeProduct({ data = { files: undefined, sku: undefined, field: undefined, value: undefined, action: undefined }, ...params }) {
        return await fetchService({ url: '/changeproduct', method: 'PATCH', data, notify: { msg: 'Изменения сохранены' }, ...params })
    }

    static async changeProducts({ data = { skus: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeproducts', method: 'PATCH', notify: { msg: 'Массовые изменения сохранены' }, data, ...params })
    }

    static async nullStocks({ data = { providerId: undefined }, ...params }) {
        return await fetchService({ url: '/nullstocks', method: 'PATCH', notify: { msg: 'Остатки обнулены' }, data, ...params })
    }

    static async removeProducts({ data = { skus: undefined }, ...params }) {
        return await fetchService({ url: '/removeproducts', method: 'DELETE', data, notify: { msg: 'Товары удалены' }, ...params })
    }

    static async loadImages({ data = { providerId: undefined, artnumbers: undefined }, ...params }) {
        return await fetchService({ url: '/loadimages', method: 'POST', data, ...params })
    }

    static async downloadImages({ data = { sku: undefined }, ...params }) {
        return await fetchService({ url: '/downloadimages', method: 'POST', data, options: { download: true }, ...params })
    }





    static async getContentCardsBySearch({ data = { providerId: undefined, search: undefined, tab: undefined, market: undefined, shop: undefined, contentFilters: undefined, page: undefined, limit: undefined }, ...params }) {
        return await fetchService({ url: '/getcontent', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async setContentManager({ data = { skus: undefined, contentManager: undefined, market: undefined }, ...params }) {
        return await fetchService({ url: '/setmanager', method: 'PATCH', data, ...params })
    }




    // static async contentValidate({ data = { providerId: undefined, skus: '[String]' }, ...params }) {
    //     return await fetchService({ url: '/validate', method: 'POST', data, ...params })
    // }

    // static async getConflicts({ data = { providerId: undefined }, ...params }) {
    //     return await fetchService({ url: '/conflicts', method: 'POST', data, ...params })
    // }

    // static async saveNds({ data = { file: undefined }, ...params }) {
    //     return await fetchService({ url: '/savends', method: 'POST', data, ...params })
    // }

    static async loadExcelStocks({ data = { providerId: undefined }, ...params }) {
        return await fetchService({ url: '/loadexcelstocks', method: 'POST', data, options: { download: true }, ...params })
    }



    static async getOzonCategories1({ data = { providerId: undefined, search: undefined, tab: undefined, market: undefined, shop: undefined, contentFilters: undefined, categoryOzonSearch: undefined }, ...params }) {
        return await fetchService({ url: '/getoozoncategories', method: 'POST', data, ...params })
    }

    static async getAvitoCategories1({ data = { providerId: undefined, search: undefined, tab: undefined, market: undefined, shop: undefined, contentFilters: undefined, categoryAvitoSearch: undefined }, ...params }) {
        return await fetchService({ url: '/getavitocategories', method: 'POST', data, ...params })
    }

    static async getCategories({ data = { search: undefined, providerId: undefined, tab: undefined, contentManager: undefined, market: undefined }, ...params }) {
        return await fetchService({ url: '/getcategories', method: 'GET', data, ...params })
    }

    static async validateOzonCards({ data = { contentManager: undefined, shop: undefined }, ...params }) {
        return await fetchService({ url: '/validateozoncards', method: 'POST', data, ...params })
    }


    static async saveSertificate({ data = {}, ...params }) {
        return await fetchService({ url: '/savesertificate', method: 'POST', data, ...params })
    }

    static async excelSertificateTmp({ data = {}, ...params }) {
        return await fetchService({ url: '/excelsertificatetmp', method: 'POST', data, options: { download: true }, ...params })
    }
}